import React from 'react';

export const DangerIcon = ({ width = 35, height = 35, color = '#C22702' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5.417C8.07.417.417 8.07.417 17.5S8.07 34.583 17.5 34.583 34.583 26.93 34.583 17.5 26.93.417 17.5.417Zm1.708 25.625h-3.416v-3.417h3.416v3.417Zm0-6.834h-3.416V8.958h3.416v10.25Z"
      fill={color}
    />
  </svg>
);
